var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.88,179.81c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.14,179.81c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.95,205.06c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.82,205.06c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,179.81c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.69,205.06c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,205.06c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.01,179.81c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.07,205.06c3.49,0,6.31-2.82,6.31-6.31s-2.82-6.31-6.31-6.31-6.32,2.83-6.32,6.31,2.83,6.31,6.32,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.64,236.62h214.61c10.44,0,18.94-8.49,18.94-18.94v-12.62c0-46.78-54.27-82.06-126.24-82.06s-126.24,35.28-126.24,82.06v12.62c0,10.44,8.49,18.94,18.94,18.94Zm-6.31-31.56c0-38.94,49.91-69.43,113.62-69.43s113.62,30.5,113.62,69.43v12.62c0,3.48-2.83,6.31-6.31,6.31H148.64c-3.48,0-6.31-2.83-6.31-6.31v-12.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.01,261.87h128.41c4.98,0,9.86,2.02,13.39,5.55l12.62,12.62c6.15,6.15,14.24,9.23,22.32,9.23s16.17-3.08,22.32-9.23l12.62-12.62c3.53-3.53,8.41-5.55,13.39-5.55h14.79c3.49,0,6.31-2.82,6.31-6.31s-2.83-6.31-6.31-6.31h-14.79c-8.43,0-16.35,3.29-22.31,9.25l-12.62,12.62c-7.38,7.37-19.4,7.37-26.78,0l-12.62-12.62c-5.96-5.96-13.89-9.25-22.31-9.25H136.01c-3.49,0-6.31,2.82-6.31,6.31s2.83,6.31,6.31,6.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.25,324.99H148.64c-10.44,0-18.94,8.49-18.94,18.94v12.62c0,17.4,14.16,31.56,31.56,31.56h189.37c17.4,0,31.56-14.16,31.56-31.56v-12.62c0-10.44-8.49-18.94-18.94-18.94Zm6.31,31.56c0,10.44-8.49,18.94-18.94,18.94H161.26c-10.44,0-18.94-8.49-18.94-18.94v-12.62c0-3.48,2.83-6.31,6.31-6.31h214.61c3.48,0,6.31,2.83,6.31,6.31v12.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,274.49h-12.62c-3.49,0-6.31,2.82-6.31,6.31s2.83,6.31,6.31,6.31h12.62c3.48,0,6.31,2.83,6.31,6.31s-2.83,6.31-6.31,6.31H136.01c-3.48,0-6.31-2.83-6.31-6.31s2.83-6.31,6.31-6.31h126.24c3.49,0,6.31-2.82,6.31-6.31s-2.83-6.31-6.31-6.31h-126.24c-10.44,0-18.94,8.49-18.94,18.94s8.49,18.94,18.94,18.94h239.86c10.44,0,18.94-8.49,18.94-18.94s-8.49-18.94-18.94-18.94Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.d2082187e6323ee3925383da2b93d596.svg";
export { ForwardRef as ReactComponent };